<!--
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2021-12-31 18:18:40
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-10-31 18:16:27
 * @FilePath: \cei-saas-platform\src\layout\components\Sidebar\Item.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<script>
import { string } from 'jszip/lib/support'
export default {
	name: 'MenuItem',
	functional: true,
	props: {
		icon: {
			type: String | Object,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		// 显示小圆点 子路由 智能台账
		isDot: {
			type: Number | String,
			default: 0
		},
		// 显示小圆点 父路由 合同管理
		isDotP: {
			type: Number | String,
			default: 0
		},
		// 显示小圆点 聊天
		isDotC: {
			type: Number | String,
			default: 0
		},
		 
	},
	render(h, context) {
		const { icon, title, isDot,isDotP,isDotC } = context.props
		const vnodes = []
		if (icon.normal) {
			// if (icon.includes('el-icon')) {
			// vnodes.push(<i class={[icon, 'sub-el-icon']} />)
			// } else {
			// vnodes.push(<svg-icon icon-class={icon}/>)
			// vnodes.push(<div class="img_wrap">
			//             <img alt="" src={icon.normal} class="normal"/>
			//             <img alt="" src={icon.hover} class="hover"/>
			//           </div>)
			// }
			vnodes.push(
				<div class="img_router">
					<i  class={[icon.normal, 'normal']} />
					<i  class={[icon.hover, 'hover']} />
				</div>
			)
		}

		if (title) {
			vnodes.push(<span slot="title">{title}</span>)
		}
		// 子路由 合同管理
		if (isDot == 1) {
			vnodes.push(<span class="dotz dotz0"></span>)
		}
		// 父路由 isDotP 合同管理 
		if (isDotP == 1) {
			vnodes.push(<span class="dotz dotz1"></span>)
		}	
		// isDotC聊天
		if (isDotC == 1) {
			vnodes.push(<span class="dotz dotz1"></span>)
		}	
		return vnodes
	}
}
</script>

<style scoped>
@import '../../../styles/iconfont2.css';
.sub-el-icon {
	color: currentColor;
	width: 1em;
	height: 1em;
}

.dotz{
	width: 8px;
	height: 8px;
	background-color: #ff0000;
	border-radius: 50%;
	position: absolute;
    
}
.dotz0{
	right: 34%;
    top: 38%;
}
.dotz1{

    right:25%;
    top: 40%;
}
</style>
